/// <reference path="env-config.d.ts" />

export const envConfig: EnvConfig = {
    environment: "STAGE",
    debuggerUrl: "https://smasi2-stage.smart-digital-solutions.de/dist/smasi2ProfileDebugger/SmartSignalsProfileDebugger.html",
    azureClientId: "b6c7b53f-33bf-41f3-adfd-e0d27a92d5e1",
};
